import React, { Component } from "react"
import MapMarkerParking from "./mapMarkerParking"
import MapOverview from "./mapOverview"
import config from "react-global-configuration"
import Spinner from "../spinner"

import PanningMap from "../../../styleguide/js/components/panning-map"
import ParkingLotPicker from "../../../styleguide/js/components/parking-lot-picker"

class Map extends Component {
  constructor(props) {
    super(props)
    this.panningMapContainerRef = React.createRef()
    this.parkingLotPickerContainerRef = React.createRef()
    this.state = {
      ajaxSpinnerActive: false,
    }
  }

  componentDidMount() {
    this.panningMap = new PanningMap({ el: this.panningMapContainerRef.current })
    new ParkingLotPicker({ el: this.parkingLotPickerContainerRef.current })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.allProducts !== prevProps.allProducts) {
      this.panningMap.initialize()
    }
  }

  getClass = (type) => {
    if (type.startsWith("We Park You Fly")) return "weparkyoufly"
    switch (type) {
      case "Budget":
        return "budget"
      case "Direct":
        return "direct"
      case "Standard":
        return "standard"
      case "Standard+":
        return "standard-plus"
      default:
        return false
    }
  }
  getUniqueProducts = (allProducts) => {
    const allSoldOut = allProducts.filter((item) => item.product.isSoldOut)
    const uniquesProducts = allProducts.filter(
      (item, index) =>
        allProducts.indexOf(
          allProducts.find(
            (i) => i.carPark.name === item.carPark.name && i.product.categoryName === item.product.categoryName && !i.product.isSoldOut,
          ),
        ) === index,
    )
    let products = [...uniquesProducts]
    allSoldOut.forEach((item) => {
      if (!products.find((i) => item.carPark.name === i.carPark.name && i.product.categoryName === item.product.categoryName)) {
        products.push(item)
      }
    })
    return products
  }

  render() {
    const textKeys = config.get("textKeys.parkingList.mapModal") || {}
    const { allProducts } = this.props
    const uniquesAllProducts = this.getUniqueProducts(allProducts)
    let changeFromParkingHouse = this.props.changeFromBooking?.parking?.name
    let centerCarparkName = "P10" //P8
    if (!uniquesAllProducts.find((i) => i.carPark && i.carPark.name === centerCarparkName)) {
      const index = Math.floor(uniquesAllProducts.length / 2)
      centerCarparkName = uniquesAllProducts[index] && uniquesAllProducts[index].carPark && uniquesAllProducts[index].carPark.name
    }
    return (
      <section className={`deck deck--white deck--padding-bottom deck--static ${this.props.isReceipt ? "no-print" : ""}`}>
        <Spinner isActive={this.props.ajaxSpinnerActive} isTransparent={this.props.ajaxSpinnerTransparent} />
        <div ref={this.parkingLotPickerContainerRef} className="parking-lot-picker__map js--parking-lot-map is-active">
          <div ref={this.panningMapContainerRef} className="panning-map js--panning-map">
            <div
              className="panning-map__inner js--panning-map-inner"
              style={{ touchAction: "pan-y", userSelect: "none", WebkitUserDrag: "none", WebkitTapHighlightColor: "rgba(0, 0, 0, 0)" }}
            >
              <div
                className="panning-map__draggable js--panning-map-draggable"
                style={{
                  WebkitTransform: "translate3d(0px, -261.01556396484375px, 0) scale3d(1, 1, 1)",
                  msTransform: "translate3d(0px, -261.01556396484375px, 0) scale3d(1, 1, 1)",
                  MozTransform: "translate3d(0px, -261.01556396484375px, 0) scale3d(1, 1, 1)",
                  transform: "translate3d(0px, -261.01556396484375px, 0) scale3d(1, 1, 1)",
                  WebkitTransformOrigin: "0px 0px",
                  msTransformOrigin: "0px 0px",
                  MozTransformOrigin: "0px 0px",
                  transformOrigin: "0px 0px",
                }}
              >
                <div className="interactive js--panning-map-interactive">
                  {uniquesAllProducts.map((item) => (
                    <MapMarkerParking
                      item={item}
                      key={item.product.id}
                      getClass={this.getClass}
                      isSingle={allProducts.length === 1}
                      isCenter={item.carPark.name === centerCarparkName}
                      changeFromParkingHouse={changeFromParkingHouse}
                      {...this.props}
                    />
                  ))}

                  <div
                    className="map-label"
                    data-positionstyle="left:18%;top:47%;"
                    style={{
                      WebkitTransform: "scale3d(1, 1, 1)",
                      msTransform: "scale3d(1, 1, 1)",
                      MozTransform: "scale3d(1, 1, 1)",
                      transform: "scale3d(1, 1, 1)",
                      left: "20%",
                      top: "52%",
                    }}
                  >
                    <span className="text">{textKeys.terminal2 || "Terminal 2"}</span>
                  </div>
                  <div
                    className="map-label"
                    data-positionstyle="left:31%;top:56%;"
                    style={{
                      WebkitTransform: "scale3d(1, 1, 1)",
                      msTransform: "scale3d(1, 1, 1)",
                      MozTransform: "scale3d(1, 1, 1)",
                      transform: "scale3d(1, 1, 1)",
                      left: "30%",
                      top: "64%",
                    }}
                  >
                    <span className="text">{textKeys.terminal3 || "Terminal 3"}</span>
                  </div>
                </div>
                <div className="image js--panning-map-image" style={{ backgroundImage: 'url("/static/photos/parkeringskort5.jpg")' }}>
                  <img src="/static/photos/parkeringskort5.jpg" alt="map" />
                </div>
              </div>
            </div>
            <div className="panning-map__overlay is-active js--mobile-overlay">
              <button className="button button--small button--general-inverted js--mobile-activate">
                <span className="text">{textKeys.activateMap || "Aktivér Kortet"}</span>
              </button>
            </div>
            <button className="button button--icon js--mobile-deactivate">
              <span className="icon">
                <svg className="svg-icon svg-icon--close-new">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                    &nbsp;
                  </use>
                </svg>
              </span>
            </button>
          </div>
          {allProducts.length > 1 ? (
            <MapOverview allProducts={allProducts} getClass={this.getClass} globals={this.props.globals} affiliateCode={this.props.affiliateCode} />
          ) : null}
        </div>
      </section>
    )
  }
}
export default Map
